import React from 'react';
import { Link } from 'gatsby';

class Hero extends React.Component {
  render() {
    return (
      <section className="hero is-fullheight">
        <div className="hero-body">
          <div className="container">
            <div className="columns">
              <div className="column">
                <h1 className="title is-title">
                  d3 In <span className="red">A</span>
                </h1>
                <h2 className="subtitle is-title">ReACtivE WOrld</h2>
              </div>
              <div className="column">
                <ol className="roman">
                  <li>
                    <Link to="/parts/reactive-world/">
                      It's a Reactive World
                    </Link>
                  </li>
                  <li>
                    <Link to="/parts/30-second-react/">
                      React in 30 Seconds
                    </Link>
                  </li>
                  <li>
                    <Link to="/parts/component-charts/">
                      Component Charts
                    </Link>
                  </li>
                  <li>
                    <Link to="/parts/idempotence/">
                      Idempotent D3
                    </Link>
                  </li>
                  <li>
                    <Link to="/parts/d3-with-react/">
                      D3 + React
                    </Link>
                  </li>
                  <li>
                    <Link to="/parts/alternative-patterns/">
                      Alternative Patterns
                    </Link>
                  </li>
                  <li>
                    <Link to="/parts/architecture/">
                      Component architeture
                    </Link>
                  </li>
                  <li>
                    Exercises&nbsp;
                    <Link to="/parts/exercise1/">
                      I
                    </Link>,&nbsp;
                    <Link to="/parts/exercise2/">
                      II
                    </Link>,&nbsp;
                    <Link to="/parts/exercise3/">
                      III
                    </Link>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Hero;
